<label mat-button mat-dialog-close class="pull-right"><i class="fa fa-times" style = "font-size: 20px;padding-bottom:5px;" aria-hidden="true"></i></label>
<!-- <video class="video-fluid z-depth-1" autoplay controls controlsList="nodownload">
    
    <source id="GeneratedVideo" src="{{videoPath}}" type="video/mp4" />
  </video> -->
<iframe width="100%" height="450" frameborder="0" class="iframe" [src]="videoPath" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
<!-- <iframe id="GeneratedVideo" width="420" height="315"
  [src]="videoPath">
  </iframe> -->